// Based on https://www.typescriptlang.org/docs/handbook/mixins.html#alternative-pattern
// semeia-disable-reexport
type Constructor = new (...args: unknown[]) => unknown;

export function applyMixins(
  derivedCtor: Constructor,
  constructors: Constructor[]
): void {
  constructors.forEach(baseCtor => {
    const descriptors = Object.getOwnPropertyDescriptors(baseCtor.prototype);

    Object.entries(descriptors).forEach(([p, desc]) => {
      if (p === "constructor") return;
      Object.defineProperty(derivedCtor.prototype, p, desc);
    });
  });
}
